import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    try {
      await login(email.trim(), password);
    } catch (err) {
      setMsg(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="lock" onSubmit={submit} data-testid="login-form">
      <h3 style={{ marginBottom: 6 }}>Iniciar sesión</h3>
      <label>Correo<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" data-testid="login-email-input" /></label>
      <label>Contraseña<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="login-password-input" /></label>
      <button className="btn btn-sol" type="submit" disabled={busy} style={{ marginTop: 16, width: "100%" }} data-testid="login-submit-btn">{busy ? "Entrando…" : "Entrar"}</button>
      {msg && <p className="err" data-testid="login-error">{msg}</p>}
      <p className="note" style={{ margin: "12px 0 0" }}>Acceso solo para psicólogos y administradores de la fundación. Las cuentas las crea el administrador.</p>
    </form>
  );
};
